/*
  Shared year / make / model picker for Shop By Vehicle.

  Data comes from assets/tc-vehicle-index.json, generated by build-fitment.py
  from supplier fitment sheets. Shape:

      { Make: { Model: [ tag, [[yearStart, yearEnd], ...] ] } }

  Only vehicles we actually carry parts for are in the index, so every
  selectable combination returns results. Submitting goes to Shopify's built-in
  tag view, /collections/all/<tag>, which needs no app and no filter setup.
*/
(function () {
  'use strict';

  var indexPromise = null;

  function loadIndex(url) {
    if (!indexPromise) {
      indexPromise = fetch(url).then(function (r) {
        if (!r.ok) throw new Error('vehicle index ' + r.status);
        return r.json();
      });
    }
    return indexPromise;
  }

  function covers(ranges, year) {
    for (var i = 0; i < ranges.length; i++) {
      if (year >= ranges[i][0] && year <= ranges[i][1]) return true;
    }
    return false;
  }

  function init(opts) {
    var yearSel = document.querySelector(opts.year);
    var makeSel = document.querySelector(opts.make);
    var modelSel = document.querySelector(opts.model);
    var button = document.querySelector(opts.submit);
    if (!yearSel || !makeSel || !modelSel || !button) return;

    var INDEX = null;
    var ph = opts.placeholders || {};
    var onReady = opts.onReady || function () {};

    function fill(sel, items, placeholder) {
      sel.innerHTML = '';
      var first = document.createElement('option');
      first.value = '';
      first.disabled = true;
      first.selected = true;
      first.textContent = placeholder;
      sel.appendChild(first);
      items.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v;
        o.textContent = v;
        sel.appendChild(o);
      });
      sel.disabled = items.length === 0;
      if (sel.parentElement) {
        sel.parentElement.classList.toggle('is-disabled', sel.disabled);
      }
    }

    function reset(sel, placeholder) {
      fill(sel, [], placeholder);
    }

    function refresh() {
      button.disabled = !(yearSel.value && makeSel.value && modelSel.value);
    }

    function allYears() {
      var s = {};
      Object.keys(INDEX).forEach(function (mk) {
        Object.keys(INDEX[mk]).forEach(function (md) {
          INDEX[mk][md][1].forEach(function (r) {
            for (var y = r[0]; y <= r[1]; y++) s[y] = 1;
          });
        });
      });
      return Object.keys(s).map(Number).sort(function (a, b) { return b - a; });
    }

    function makesForYear(year) {
      return Object.keys(INDEX).filter(function (mk) {
        return Object.keys(INDEX[mk]).some(function (md) {
          return covers(INDEX[mk][md][1], year);
        });
      }).sort();
    }

    function modelsFor(year, make) {
      var models = INDEX[make] || {};
      return Object.keys(models).filter(function (md) {
        return covers(models[md][1], year);
      }).sort();
    }

    yearSel.addEventListener('change', function () {
      reset(modelSel, ph.model || 'Model');
      fill(makeSel, makesForYear(+yearSel.value), ph.make || 'Make');
      refresh();
    });

    makeSel.addEventListener('change', function () {
      fill(modelSel, modelsFor(+yearSel.value, makeSel.value), ph.model || 'Model');
      refresh();
    });

    modelSel.addEventListener('change', refresh);

    button.addEventListener('click', function () {
      var entry = (INDEX[makeSel.value] || {})[modelSel.value];
      if (!entry) return;
      // Callers can take over navigation (the collection page keeps the shopper
      // in the collection they are browsing and preserves any pending filters).
      if (typeof opts.onSubmit === 'function') {
        opts.onSubmit(entry[0], makeSel.value, modelSel.value, yearSel.value);
        return;
      }
      window.location.href = '/collections/all/' + entry[0];
    });

    loadIndex(opts.indexUrl).then(function (data) {
      INDEX = data;
      fill(yearSel, allYears(), ph.year || 'Year');
      reset(makeSel, ph.make || 'Make');
      reset(modelSel, ph.model || 'Model');
      refresh();
      onReady();
    }).catch(function () {
      reset(yearSel, 'Unavailable');
    });
  }

  function lookupTag(url, tag) {
    return loadIndex(url).then(function (data) {
      var makes = Object.keys(data);
      for (var i = 0; i < makes.length; i++) {
        var models = data[makes[i]];
        var keys = Object.keys(models);
        for (var j = 0; j < keys.length; j++) {
          if (models[keys[j]][0] === tag) {
            return { make: makes[i], model: keys[j] };
          }
        }
      }
      return null;
    });
  }

  window.TCVehiclePicker = { init: init, lookupTag: lookupTag };
})();
